export default __webpack_public_path__ + "static/media/female_6.ed86279d.png";